import { gql } from '@apollo/client'

export const GET_SESSIONS_QUERY = gql`
  query Sessions($input: SessionsInput!) {
    sessions(input: $input) {
      sessions {
        id
        sessionUuid
        userId
        email
        accessTokenExpiry
        refreshTokenExpiry
        initiatedAt
        absoluteExpiry
        lastActivity
        terminatedAt
        sessionState
      }
      pagination {
        page
        perPage
        total
      }
    }
  }
`

export const GET_SESSIONS_WITHOUT_PAGINATION_QUERY = gql`
  query SessionsWithoutPagination($input: SessionsWithoutPaginationInput!) {
    sessionsWithoutPagination(input: $input) {
      sessionId
      sessionUuid
    }
  }
`
export const GET_SESSIONS_CONFIGURATION_QUERY = gql`
  query SessionConfiguration {
    sessionConfiguration {
      accessTokenExpiryMinutes
      refreshTokenExpiryMinutes
      sessionIdleTimeoutMinutes
      sessionAbsoluteTimeoutMinutes
      maxSessionsPerUser
      require2faForLogin
      max2faAttempts
      maxLoginAttempts
      forceLogoutOnPermissionChange
      lockDurationMinutes
      permenetLockAterAttempts
      webAccessTokenExpiryMinutes
      otpTTLSeconds
      otpCoolDownSeconds
      otpMaxResendSeconds
      pending2FASessionSecond
      authenticationHistoryRetentionDays
    }
  }
`

export const GET_AUTHENTICATION_ATTEMPTS_QUERY = gql`
  query AuthenticationAttempts($input: AuthenticationAttemptsInput) {
    authenticationAttempts(input: $input) {
      attempts {
        id
        sessionId
        userId
        identifier
        outcome
        reason
        stage
        loginSource
        authenticationMethod
        entityType
        entityId
        entityCode
        ipAddress
        userAgent
        deviceType
        os
        browser
        occurredAt
        expiresAt
      }
      nextPageToken
    }
  }
`

export const UPDATE_SESSIONS_CONFIGURATION_MUTATION = gql`
  mutation UpdateSessionConfiguration(
    $input: UpdateSessionConfigurationInput!
  ) {
    updateSessionConfiguration(input: $input) {
      message
    }
  }
`
export const TERMINATE_SESSIONS_MUTATION = gql`
  mutation TerminateSessions($input: TerminateSessionsInput!) {
    terminateSessions(input: $input) {
      message
      terminatedCount
    }
  }
`
